import { globals } from "@client/globals";
import { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { connectCustom } from "@client/lib/misc";
import {
  getSettingValueSelector,
  getVisibilitySelector,
  makeEntityTypeSelector,
  TargetSelector
} from "@client/selectors";
import { type BaseAppState, type EntityRef, type WithClassName } from "@client/types";
import { type WithChildren } from "@client/types/WithChildren";
import classNames from "classnames";
import Component, { type MapProps } from "./component";
import { isStackChildren } from "./lib";
import { makeStyleSelector } from "./selectors";

export type LayoutContainerContainerProps = EntityRef &
  Partial<WithClassName> &
  WithChildren & {
    draggable?: boolean;
    rootChildren?: any;
    style?: React.CSSProperties;
    title?: string;
    viewonly?: boolean;
  };
const makeMapStateToProps = () => {
  const entityTypeSelector = makeEntityTypeSelector();
  const styleSelector = makeStyleSelector();
  const directionSelector = getSettingValueSelector(TargetSelector.Entity, "direction");
  const visibilitySelector = getVisibilitySelector(TargetSelector.Entity);

  return (state: BaseAppState, props: LayoutContainerContainerProps): MapProps & WithIsVisibleHOCProps => {
    const visibility = visibilitySelector(state, props);
    return {
      ...props,
      className: classNames("wsc_entity", props.className, {
        faded: visibility.isVisible === false && state.isEditMode,
        ver: isStackChildren(directionSelector(state, props))
      }),
      context: state.context,
      type: entityTypeSelector(state, props),
      isVisible: globals.mode === "builder" || visibility.isVisible,
      style: styleSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
